import LayoutApp from "@lhd/components/CloneApp/LayoutApp";
import { convertDataToDataForm } from "@lhd/components/CloneApp/untils";
import { APP_PART_TYPES } from "@lhd/features/Apps/AppForm/constants";
import { AppRecordV2, AppV2, AppSelectionList } from "@lhd/types";
import { Form } from "antd";
import { FormInstance } from "antd/es/form/hooks/useForm";
import { useEffect, useMemo } from "react";
import { Styles } from "./styled";

interface IProps {
  dataApp: AppV2;
  appRecord: AppRecordV2;
  selectionDataList?: AppSelectionList;
}

const EmploymentContractPDF = ({
  dataApp,
  appRecord,
  selectionDataList,
}: IProps) => {
  const [form] = Form.useForm();
  const appType = dataApp?.app_type;

  // Filter out the title LABEL from app_parts to avoid duplicate
  // (we already render it as contract-title)
  const filteredDataApp = useMemo(() => {
    if (!dataApp?.app_parts) return dataApp;
    return {
      ...dataApp,
      app_parts: dataApp.app_parts.filter((part) => {
        const text = (part.label_text || part.name || "")
          .replace(/<[^>]*>/g, "")
          .replace(/&nbsp;|&ensp;|&emsp;/g, " ")
          .trim();

        // Remove the Category, Status, and Date fields as requested
        if (["カテゴリー", "ステータス", "日付"].includes(text)) {
          return false;
        }

        if (
          part.app_part_type === APP_PART_TYPES.LABEL ||
          part.app_part_type === APP_PART_TYPES.RICH_TEXT
        ) {
          if (text.includes("雇用契約書") && text.includes(" 雇用契約書")) {
            return false;
          }
          // Remove the "1. ", "2. ", "3. " labels as requested by the user
          // Supports full-width numbers and dots
          if (/^[0-9０-９]+[.．]/.test(text)) {
            return false;
          }
        }
        return true;
      }),
    };
  }, [dataApp]);

  useEffect(() => {
    if (appRecord) {
      const result = convertDataToDataForm(
        dataApp?.app_parts || [],
        appRecord,
        true,
      );
      form.setFieldsValue(result);
    }
  }, [appRecord, dataApp?.app_parts, form]);

  return (
    <Styles>
      <table className="pdf-print-table">
        <thead>
          <tr>
            <td>
              <div className="pdf-print-header-space" />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {/* Centered title */}
              <div className="contract-title">雇用契約書 兼 雇用契約書</div>

              {/* Form content without duplicate title label */}
              <Form form={form} disabled>
                <LayoutApp
                  form={form}
                  dataApp={filteredDataApp}
                  appRecord={appRecord}
                  appType={appType}
                  isEditPage={true}
                  isEditing={false}
                  isPDF={true}
                  selectionDataList={selectionDataList}
                />
              </Form>
            </td>
          </tr>
        </tbody>
      </table>
    </Styles>
  );
};

export default EmploymentContractPDF;
